<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import WidgetTopPicks from '@components/widgets/widget-top-picks.vue'
import WidgetRankingOverview from '@components/widgets/widget-ranking-overview.vue'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, WidgetTopPicks, WidgetRankingOverview },
}
</script>

<template>
  <Layout>
    <v-container fluid>
      <WidgetTopPicks />
      <WidgetRankingOverview />
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
